import { useConnect } from '@puzzlehq/sdk';
import { Button, buttonVariants, Spinner } from 'ui_2';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useDappState } from '@src/hooks/useDappState';
import { useHasInjectedConnection } from '@puzzlehq/frontend-utils';
import { BiLinkExternal } from 'react-icons/bi';

export const ConnectButton = () => {
  const { connect, isConnected, loading } = useConnect({
    permissions: {
      programIds: {
        [import.meta.env.VITE_NETWORK!]: [
          import.meta.env.VITE_COIN_CONTRACT!,
          import.meta.env.VITE_TICKET_CONTRACT!,
        ],
      },
    },
    dAppInfo: {
      name: 'Puzzle Arcade Quests',
    },
  });

  const { hasInjectedConnection, isLoading } = useHasInjectedConnection();

  if (isConnected) return null;

  if (hasInjectedConnection === false && isLoading === false) {
    return (
      <a
        href='https://app.puzzle.online/wallet'
        target='_blank'
        className={buttonVariants({
          size: 'md',
          className: 'items-center gap-2',
        })}
      >
        Download Puzzle Wallet
        <BiLinkExternal />
      </a>
    );
  }

  return (
    <Button
      onClick={connect}
      size='md'
      variant='primary'
      disabled={loading}
      className='items-center gap-2'
    >
      Connect Wallet
      {loading && <Spinner />}
    </Button>
  );
};

export const ConnectOrAccount = ({
  showOnConnected = true,
}: {
  showOnConnected?: boolean;
}) => {
  const { isConnected, error } = useConnect({
    permissions: {
      programIds: {
        [import.meta.env.VITE_NETWORK!]: [
          import.meta.env.VITE_COIN_CONTRACT!,
          import.meta.env.VITE_TICKET_CONTRACT!,
        ],
      },
    },
    dAppInfo: {
      name: 'Puzzle Arcade Quests',
    },
  });

  useEffect(() => {
    if (error) {
      const errorStr =
        typeof error === 'string' ? error : (error as Error).message;
      toast.error(errorStr);
    }
  }, [error]);

  const { account } = useDappState();

  if (account && isConnected && showOnConnected === false) {
    return null;
  } else if (isConnected === false) {
    return <ConnectButton />;
  }
};
